import { render, staticRenderFns } from "./DynamicTabs.vue?vue&type=template&id=348d307a&"
import script from "./DynamicTabs.vue?vue&type=script&lang=js&"
export * from "./DynamicTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports